var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('full-page',{ref:"fullpage",attrs:{"id":"fullpage","options":_vm.options}},[_c('div',{staticClass:"section",style:(_vm.bgi)},[_c('home')],1),_vm._v(" "),_c('div',{staticClass:"section",style:(_vm.bgc)},[_c('resume')],1)]),_vm._v(" "),_c('div',{attrs:{"id":"footer"}},[_vm._v("Footer")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f844130","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 